import { makeSvgIcon } from '../makeSvgIcon'

export const arrow = makeSvgIcon(<path d="M12 22L2 2L12 8L22 2L12 22Z" />)
